/**
 * This file responsible for the download chart flow. The first time a user
 * requests to download a chart, they will be asked for their email address
 * and to agree to the terms and conditions.
 *
 * The flow is roughly like this:
 *
 * - Click 'download chart button'
 * - Do we have state.user?
 *    - No, trigger request user details modal flow
 *    - Yes, go to next step
 * - Trigger file download
 */
import { getUser } from "../user";
import { getChart, setChart } from "../chart"; // eslint-disable-line no-unused-vars
import { showModal, modals, mailchimpRequest } from "../../state/modal";
import analytics from "../../utils/analytics";

/**
 * Request chart download - check for user details. If available then skip
 * straight to triggering the chart download. If _not_ available, show the
 * standard user request details.
 **/
// eslint-disable-next-line no-unused-vars
export const requestChartDownload = ({ chartId, groupId }) => (
  dispatch,
  getState
) => {
  const state = getState();
  const user = getUser(state);

  // set chart
  dispatch(setChart({ chartId, groupId }));

  // get user details
  const hasUser =
    typeof user.email === "string" &&
    user.email.length > 1 &&
    user.termsAgreed === true;

  if (hasUser) {
    // if user details, dispatch immediate download
    dispatch(downloadChart());
  } else {
    // if no user details, dispatch download modal flow
    const modal = { modalType: modals.DOWNLOAD_CHART };
    dispatch(showModal(modal));
  }
};

// eslint-disable-next-line no-unused-vars
export const prepChartDownload = () => (dispatch, getState) => {
  const state = getState();
  const user = getUser(state);

  mailchimpRequest(user.email, user.newsletter).then(() => {
    dispatch(
      showModal({
        modalType: modals.DOWNLOAD_SUCCESS,
        modalProps: {
          text:
            "Your download will start in a few moments. Check your browser's download folder."
        }
      })
    );
    dispatch(downloadChart());
  });
};

/**
 * Trigger the download of the current chart
 */
export const downloadChart = () => (dispatch, getState) => {
  const state = getState();
  const chartDetails = getChart(state);
  const filePrefix = `chart/state-of-european-tech-2017-`;
  const fileSuffix = `${chartDetails.chartId}-${chartDetails.groupId}`;
  const filename = `${filePrefix}${fileSuffix}.jpg`;
  const chart = `${window.location.origin}/${filename}`;
  analytics("send", "event", "download", "downloadChart", {
    chart
  });
  // Create a temporary element and click it to download the image.
  // These images do not have the "Content-Disposition: attachment" header.
  // So we do this to try and force the image to download, instead of display
  // in the browser
  const element = document.createElement("a");
  element.setAttribute("href", chart);
  element.setAttribute("download", filename);
  element.style.display = "none";

  // if download attribute not supported, just open in a new browser window
  if (!element.hasAttribute("download")) element.target = "_blank";

  // Attach, click, remove:
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};



// WEBPACK FOOTER //
// ./src/state/download/chart.js